import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { PricingSection } from '../components/PricingSection';
import { ProductImage } from '../components/ProductImage';
import { IncludesSection } from '../components/IncludesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-cream-50" data-id="element-227">
      <Header data-id="element-228" />
      <main data-id="element-229">
        <Hero data-id="element-230" />
        <PricingSection data-id="element-231" />
        <ProductImage data-id="element-232" />
        <IncludesSection data-id="element-233" />
        <BenefitsSection data-id="element-234" />
        <TestimonialsSection data-id="element-235" />
        <ForWhomSection data-id="element-236" />
        <CTASection data-id="element-237" />
      </main>
      <Footer data-id="element-238" />
    </div>;
}